import React from 'react'
import './BlogHeaderContainer.css'

function BlogHeaderContainer({ containerObject, templateName, contentId, dataZone }) {

    const blogHeaderStyle = {
        height: '64px',
        backgroundColor: '#fff ',
        borderBottom: '2px solid #35649a',
    }

    const blogHeaderList = {
        display: 'flex',
        margin: '0',
    }

    const loginLogoImg = {
        height: '45px',
        width: '100px',
        cursor:"pointer"
    }
    const cxmHeaderLogo = {
        display: 'flex',
        color: "rgb(0, 0, 0)",
        fontSize: '15px',
        fontWeight: 'bold',
        marginTop: '30px',
        marginRight: '3rem'
    }

    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId}
                data-template-name={templateName} className="vast-plugin-content row gx-0">

                <div className='blogHeaderStyle' style={blogHeaderStyle}>
                    <ul className='blogHeaderList' style={blogHeaderList}>
                        <li className="blog-logo" style={{ display: 'flex' }}>
                            <a role="menuitem" className="blog-link" href="#">
                                <img className="loginLogoImg" style={loginLogoImg} src="/cmsadminui/static-assets/VastLogo.png" />
                            </a>
                        </li>
                        <span className='cxmHeaderLogo' style={cxmHeaderLogo}>BLOG</span>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default BlogHeaderContainer
